export const displayUnitsFilter = {
  key: 'unitType',
  query: 'unitType',
  isAvailable: () => true,
  withAllTypesKey: 'withAllTypes',
};
